<div class="d-flex flex-column h-100 w-100" [class.templateExcelImport]="!exportMode">
  <div *ngIf="!exportMode" class="aiMappingHeader">
    <dx-button
        class="aiMappingButton w-100"
        [text]="'Automatisch zuordnen' | translate"
        icon="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='white'><path d='M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9z'/><path d='M19 14l.9 2.6L22.5 17.5l-2.6.9L19 21l-.9-2.6L15.5 17.5l2.6-.9z'/></svg>"
        stylingMode="contained"
        [disabled]="aiMappingRunning"
        (onClick)="aiMapping.emit()"
    ></dx-button>
    <div class="mappingLegend d-flex flex-row flex-wrap">
      <button
          *ngFor="let certainty of mappingCertainties"
          type="button"
          class="legendPill"
          [class.legendPill--active]="isMappingCertaintyShown(certainty)"
          [attr.aria-pressed]="isMappingCertaintyShown(certainty)"
          [title]="'Liste auf diese Zuordnungen filtern' | translate"
          (click)="toggleMappingCertainty(certainty)"
      >
        <span class="legendDot legendDot--{{ certainty }}"></span>{{ mappingCertaintyCounts[certainty] }} {{ certainty | translate }}
      </button>
    </div>
  </div>
  <div class="flex-fill" style="min-height: 0">
<dx-data-grid
    [height]="'100%'"
    [showColumnHeaders]="false"
    [selectedRowKeys]="rowSelection"
    [keyExpr]="'id'"
    [columns]="columns"
    [dataSource]="filteredExcelModel"
    [autoNavigateToFocusedRow]="true"
    (onRowClick)="onRowClicked($event)"
>
  <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
  <dxo-toolbar>
    <dxi-item name="searchPanel" location="after"></dxi-item>
  </dxo-toolbar>
  <dxo-load-panel [enabled]="false"></dxo-load-panel>
  <dxo-scrolling [mode]="'virtual'"></dxo-scrolling>
  <dxo-row-dragging [onDragStart]="onDragStart" [onDragMove]="onDragMove" [onDragEnd]="onDragEnd" [onAdd]="onDrop" [onReorder]="onReorder" [group]="'dragDropGroup'" dragTemplate="dragTemplate" [allowDropInsideItem]="true" [dropFeedbackMode]="'indicate'"></dxo-row-dragging>
  <dxo-editing mode="cell" [allowUpdating]="!!exportMode" [startEditAction]="'click'"></dxo-editing>
  <!-- template for the dragged item -->
  <div
      *dxTemplate="let dragInfo of 'dragTemplate'"
      class="item dx-card dx-theme-text-color dx-theme-background-color shadow-lg p-3 bg-body rounded dragTemplate"
  >
    <div>
      {{ getDragInfo(dragInfo.itemData) }}
    </div>
  </div>

  <div
      *dxTemplate="let cell of 'importCellTemplate'" class="w-100 d-flex flex-row align-items-center">
    <div class="d-flex flex-column flex-grow-1 overflow-hidden" [ngClass]="{ inUse: cell.data.pimFields?.length > 0 }">
      <div class="templateExcelHead text-truncate" [title]="cell.data.title">{{ cell.data.title }}</div>
      <div class="templateExcelLine text-truncate" [title]="cell.data.row1">{{ cell.data.row1 }}</div>
      <div class="templateExcelLine text-truncate" [title]="cell.data.row2">{{ cell.data.row2 }}</div>
      <div class="templateExcelLine text-truncate" *ngIf="cell.data.pimFields?.length > 0" [title]="getDragInfo(cell.data)"><i class="dx-icon dx-icon-link align-middle"></i>&nbsp;{{ getDragInfo(cell.data) }}</div>
    </div>
    <span
        class="mappingLight mappingLight--{{ getMappingCertainty(cell.data) }}"
        [title]="getMappingCertainty(cell.data) | translate"
    ></span>
  </div>


  <div
      *dxTemplate="let cell of 'exportCellTemplate'">
    <div class="d-flex flex-column w-100" [ngClass]="{ inUse: cell.data.pimFields?.length > 0 }">
      <div class="templateExcelHead text-truncate" [title]="cell.data.title">{{ cell.data.title }}</div>
      <div class="templateExcelLine text-truncate" *ngIf="cell.data.pimFields?.length > 0" [title]="getDragInfo(cell.data)"><i class="dx-icon dx-icon-link align-middle"></i>&nbsp;{{ getDragInfo(cell.data) }}</div>
      <div class="templateExcelLine text-truncate" *ngIf="!cell.data.pimFields?.length" [title]="cell.data.defaultValue">{{ cell.data.defaultValue }}</div>
    </div>
  </div>

  <div
      *dxTemplate="let cell of 'exportCellEditTemplate'"
      class="templateExcelExportColumn"
      id="templateExcelDiv_{{ cell.data.id }}"
  >
    <div>
      <div class="d-flex flex-row" [ngStyle]="{ gap: '0.5rem' }">
        <div class="d-flex flex-column flex-grow-1">
          <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" [ngStyle]="{width: '100%'}">
            <label class="placeLabel {{ cell.data.title?.length > 0 ? 'placeLabelSmall' : '' }}">FIELD_TITLE</label>
            <dx-text-box [(value)]="cell.data.title" placeholder="" (onValueChanged)="update($event)"></dx-text-box>
          </div>
          <div *ngIf="cell.data.pimFields == null || cell.data.pimFields?.length == 0" class="templateExcelContent">
            <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}" [ngStyle]="{width: '100%'}">
              <label class="placeLabel {{ cell.data.defaultValue?.length > 0 ? 'placeLabelSmall' : '' }}">
                FIELD_VALUE
              </label>
              <dx-text-box
                  [(value)]="cell.data.defaultValue"
                  [showClearButton]="true"
                  placeholder=""
                  (onValueChanged)="update($event)"
              ></dx-text-box>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</dx-data-grid>
  </div>
</div>
<dx-popover *ngIf="popoverVisible"
            [target]="popoverTarget"
            [(visible)]="popoverVisible"
            [showCloseButton]="true"
            [shading]="false"
            [hideOnOutsideClick]="true"
            width="auto"
            height="auto"
            position="right"
            minWidth="20%"
            (onHiding)="onCloseFieldSettings($event)"
>
  <np-advanced-template-fieldsettings
      [excelElement]="popoverElement"
      [mappings]="mappings"
      (onUpdate)="updateNew($event)"
      [exportMode]="exportMode"
  ></np-advanced-template-fieldsettings>
</dx-popover>
